module.exports = __webpack_public_path__ + "static/img/grow4_light.c1a3fa6e.png";